module.exports = __webpack_public_path__ + "img/no-image-icon-23488.99c22bc3.png";